import { FC, useEffect } from "react"
import s from './DetailServices.module.scss'
import { NavLink, useParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../store/hooks"
import { fetchByDetailservices } from "../../store/slices/servicesSlice"
import Loader from "../../components/Loader/Loader"
import { Helmet } from "react-helmet-async"
import TopBanner from "../../components/TopBanner/TopBanner"
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs"
import ServicesInfoSection from "./ServicesInfoSection/ServicesInfoSection"
import HeroSection from "./HeroSection/HeroSection"
import ProjectExamples from "./ProjectExamples/ProjectExamples"
import { scrollToTop } from "../../utils"

const DetailServices:FC =()=>{
    const { id, name } = useParams()
    const dispatch = useAppDispatch()
    const { detail, loading } = useAppSelector(state => state.services)

    useEffect(()=>{
        scrollToTop()
        dispatch(fetchByDetailservices(Number(id)))
    },[])

    if (loading) return <Loader />

    return(
        <>
         {detail && (
                <Helmet>
                    <title>
                        {detail.title_hero_h1} | Услуги | Phoenix Programs
                    </title>

                    <meta
                        name="description"
                        content={
                            detail.description_hero
                                ? detail.description_hero.replace(/[#_*>\n]/g, '').slice(0, 160)
                                : `${detail.title_hero_h1} — услуга компании Phoenix Programs`
                        }
                    />

                    <link
                        rel="canonical"
                        href={`https://phoenix-programs.ru/services/${id}/${encodeURIComponent(
                            detail.title_hero_h1 || ''
                        )}`}
                    />

                    {/* Open Graph */}
                    <meta property="og:type" content="article" />
                    <meta property="og:locale" content="ru_RU" />
                    <meta
                        property="og:url"
                        content={`https://phoenix-programs.ru/services/${id}/${encodeURIComponent(
                            detail.title_hero_h1 || ''
                        )}`}
                    />
                    <meta
                        property="og:title"
                        content={`${detail.title_hero_h1} | Phoenix Programs`}
                    />
                    <meta
                        property="og:description"
                        content={
                            detail.description_hero
                                ? detail.description_hero.replace(/[#_*>\n]/g, '').slice(0, 160)
                                : `услуга компании Phoenix Programs`
                        }
                    />
                    <meta property="og:image" content="https://phoenix-programs.ru/logo192.png" />

                    {/* Twitter */}
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta
                        name="twitter:title"
                        content={`${detail.title_hero_h1} | Phoenix Programs`}
                    />
                    <meta
                        name="twitter:description"
                        content={
                            detail.description_hero
                                ? detail.description_hero.replace(/[#_*>\n]/g, '').slice(0, 160)
                                : `услуга Phoenix Programs`
                        }
                    />
                    <meta name="twitter:image" content="https://phoenix-programs.ru/logo192.png" />

                    <meta name="robots" content="index, follow" />
                </Helmet>
            )}

        <TopBanner title={name} />
        <Breadcrumbs>
            <NavLink to={'/'}>Главная</NavLink>
            /
            <span>{name}</span>
        </Breadcrumbs>
      {
          detail?.description_hero !== '' && detail?.title_hero_h1 !== '' ?
        <>
            <HeroSection 
            title={detail?.title_hero_h1}
            images={detail?.images || []}
            description_hero={detail?.description_hero}
            title_hero_h2={detail?.title_hero_h2}
            />
            <ServicesInfoSection 
            icon={detail?.icon_services || undefined}
            section_title_h1={detail?.section_title_h1}
            section2_title_h1={detail?.section2_title_h1}
            section_description={detail?.section_description}
            section2_description={detail?.section2_description}
            data={detail?.list_projects || []}
            />
        </>
        :
        <div className="container" style={{ padding: '80px 0', textAlign: 'center' }}>
                <h2 className={s.error}>Данных пока нет</h2>
        </div>
        }
        </>
    )
}

export default DetailServices